// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const trapinch: PokeData = {
  "id": 328,
  "name": "trapinch",
  "height": 7,
  "weight": 150,
  "base_experience": 58,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "sand-attack",
    "bite",
    "hyper-beam",
    "earthquake",
    "fissure",
    "dig",
    "bide",
    "rock-slide",
    "feint-attack",
    "mud-slap",
    "sandstorm",
    "crunch",
    "superpower",
    "astonish",
    "sand-tomb",
    "feint",
    "earth-power",
    "bulldoze",
    "laser-focus"
  ],
  "moves": [
    "bite",
    "earthquake",
    "fissure",
    "rock-slide",
    "mud-slap",
    "sandstorm",
    "crunch",
    "superpower",
    "earth-power",
    "magnitude",
    "mud-shot",
    "bonemerang",
    "bone-throw"
  ],
  "evolution_chain": {
    "id": 166,
    "item": null,
    "species": [
      {
        "name": "trapinch",
        "order": 356,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "vibrava",
        "order": 357,
        "types": [
          PokeType.GROUND,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 328,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "flygon",
        "order": 358,
        "types": [
          PokeType.GROUND,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 329,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 45,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45,
    "speed": 10,
    "ability_power": 100
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
